import { portalResources, portalText } from "./portal.js";

/**
 * AMENDED 2026-10-21 (plan-026 PORTAL, design §37.5): the Spanish and Portuguese catalogue rows. A
 * publication names its voice "Spanish voice" / "Portuguese voice"; the description is matched both as
 * "Selected by the product owner for …" (the el/en rows' wording) and as "Auditioned for es." /
 * "Auditioned for pt." (what `tools/catalogue-emit/src/language.ts` writes for a voice it inserts). The
 * portal's display language stays English and Greek (ADR 0051).
 */
const VOICE_COPY = [
  "voiceCatalogue.greek",
  "voiceCatalogue.english",
  "voiceCatalogue.spanish",
  "voiceCatalogue.portuguese",
  "voiceCatalogue.candidate",
  "voiceCatalogue.selectedGreek",
  "voiceCatalogue.selectedEnglish",
  "voiceCatalogue.selectedSpanish",
  "voiceCatalogue.selectedPortuguese",
  "voiceCatalogue.auditionedSpanish",
  "voiceCatalogue.auditionedPortuguese",
] as const;

/** Curated generic voice metadata; provider names and unknown catalogue content retain their original wording. */
export function voiceCatalogueText(value: string): string {
  const key = VOICE_COPY.find((one) => value === portalResources.en.shell[one] || value === portalResources.el.shell[one]);
  return key === undefined ? value : portalText("shell", key);
}
